export function generateHexId(length: number): string {
  return Array.from(crypto.getRandomValues(new Uint8Array(length / 2)))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

export function generateTraceHeaders() {
  const traceId = generateHexId(32);
  const spanId = generateHexId(16);
  const b3Header = `${traceId}-${spanId}-1`;

  return {
    b3: b3Header,
    "trace-id": traceId,
  };
}

export function getTraceIdFromError(error: any): string | undefined {
  if (error?.config?.headers?.["trace-id"]) {
    return error.config.headers["trace-id"];
  }
  return undefined;
}
